// Themes
import { employeeYearInReviewTheme } from '@/components/EmployeeYearInReview/theme';

// Types
import {
  SnakeAnimationConfig,
  GridConfig,
  HiddenRegion,
  LinePath,
  PlusSign,
} from './types';

const { rawColors } = employeeYearInReviewTheme;

export const DEFAULT_BACKGROUND_COLOR = rawColors.dotGridBackground;
export const DEFAULT_DOT_COLOR = rawColors.dotColor;
export const DEFAULT_LINE_COLOR = rawColors.lineColor;
export const DEFAULT_PLUS_COLOR = rawColors.plusColor;

export const DEFAULT_GRID_CONFIG: GridConfig = {
  cols: 19,
  rows: 11,
  dotSize: 11,
  paddingX: 140,
  paddingY: 90,
  dotColor: DEFAULT_DOT_COLOR,
};

export const DEFAULT_ANIMATION_CONFIG: Required<SnakeAnimationConfig> = {
  framesPerSegment: 30,
  snakeLength: 2,
  staggerDelay: 15,
  loopPause: 60,
};

export const DEFAULT_LINES: LinePath[] = [
  {
    points: [
      { x: 1, y: 4 },
      { x: 5, y: 4 },
    ],
  },
  {
    points: [
      { x: 11, y: 1 },
      { x: 16, y: 1 },
    ],
  },
  {
    points: [
      { x: 9, y: 10 },
      { x: 10, y: 10 },
      { x: 10, y: 9 },
      { x: 11, y: 9 },
    ],
  },
  {
    points: [
      { x: 0, y: 7 },
      { x: 0, y: 9 },
    ],
  },
  {
    points: [
      { x: 12, y: 8 },
      { x: 15, y: 8 },
      { x: 15, y: 6 },
    ],
  },
];

export const DEFAULT_PLUS_SIGNS: PlusSign[] = [
  { position: { x: 1, y: 1 } },
  { position: { x: 17, y: 8 } },
];

export const DEFAULT_HIDDEN_REGIONS: HiddenRegion[] = [
  { minX: 2, minY: 2, maxX: 14, maxY: 3 },
  { minX: 8, minY: 4, maxX: 16, maxY: 5 },
  { minX: 1, minY: 6, maxX: 14, maxY: 7 },
];
